import { RendererElement, RendererNode, VNode } from 'vue'

export const passwordPt = (
  instance?: VNode<RendererNode, RendererElement, { [key: string]: any }>
) => {
  if (!instance) return
  return {
    pcInputText: {
      root: {
        class: instance.props?.invalid ? 'p-invalid font-14-n' : 'font-14-n'
      }
    }
  }
}
